<template>
   <v-navigation-drawer
        v-model="showMenu"
        :expand-on-hover="false"
        :mini-variant="showMini"
        app
        clipped
        width="300"
     darks
      colors="grey darken-1"
      
      class="pt-3"
      >
    
        <v-list
          dense
          nav
          class="py-0"
        > <v-list-item two-line class="mb-2">
          
            <v-list-item-avatar class="mt-2" @click="toggleMini">
               <v-img v-if="company._supplier.logo" v-avatar:logo :src="company._supplier.logo"></v-img>
             <v-icon v-else>home</v-icon>
            </v-list-item-avatar>

            <v-list-item-content @click="home">
              <v-list-item-title v-html="company._supplier.name"></v-list-item-title>
            <v-list-item-subtitle>Algemene vragenlijst</v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action v-if="false">
              <v-btn icon @click="toggleMini">
              <v-icon>chevron_left</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-list-item
                v-for="(contact) in settings.contacts"
                :key="contact.name"
              
                 v-if="isMain && !showMini">
                <v-list-item-avatar>
                  <img v-if="contact.logo" :src="avatar(contact.logo)">
                  <v-icon v-else class="">person</v-icon>
                </v-list-item-avatar>
  
                <v-list-item-content>
                  <v-list-item-title>{{contact.name}}</v-list-item-title>
                 <v-list-item-subtitle v-html="contact.jobtitle"></v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
          <v-divider class="mb-3"></v-divider>
    </v-list>
        <slot name="menu"></slot>
    
      </v-navigation-drawer>
</template>
<script>
import {
  mapState, mapMutations, mapGetters
} from 'vuex'

export default {
  props: ['isMain', 'company'],
  data: () => ({
      drawer: true
  }),
  computed: {
    ...mapGetters('auth', ["Role"]),
    ...mapState('auth', ["settings"]),
    ...mapState('app', ["menu","mini","chat","edit","template","preview"]),
    showMenu: {
      get() {
        return this.menu && !this.preview
      },
      set(value) {
        this.setMenu(value)
      }
    },
    showMini: {
      get() {
        return this.mini
      },
      set(value) {
        this.setMini(value)
      }
    }
  },
  methods: {
    ...mapMutations('app', ["setMenu","toggleMini"]),
      home () {
          this.$emit('home', this.company)
      }
  }
};
</script>
<style>
.v-navigation-drawer__content .v-list-item__title {
  font-size: 0.75rem!important;
}
</style>